import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import currency from "currency.js";

import { DeleteIcon } from "../Icons";

const WarehouseIssueItemModalTable = ({
  index,
  el,
  deleteItem,
  updateQuantity,
  key,
  issueToData,
  serialNum,
  receivingOfficers,
  contracts,
  storageLocation,
}) => {
  const [showInput, setShowInput] = useState(false);
  const [inputValue, setInputValue] = useState(0);

  const update = (e, inx) => {
    if (e.key === "Enter") {
      if (inputValue === "" || parseFloat(inputValue) < 1)
        return toast.error(`Quantity can not be empty or less than one`);

      setShowInput(false);
      updateQuantity(inputValue, inx);
    }
  };

  //  console.log({
  //   el,
  //   issueToData,
  //   receivingOfficers,
  //   contracts,
  //   storageLocation,
  // });

  useEffect(() => {
    setInputValue(el.qty);
  }, [el.qty]);

  return (
    <tr key={key}>
      {serialNum && <td>{el?.serialNum}</td>}
      <td>{el.itemId}</td>
      <td onClick={() => setShowInput(false)}>{el.itemName}</td>
      <td onClick={() => setShowInput(true)}>
        {showInput ? (
          <input
            type="number"
            className="inputTable"
            value={inputValue}
            onChange={e => !serialNum && setInputValue(e.target.value)}
            onKeyDown={e => !serialNum && update(e, index)}
          />
        ) : (
          el.qty
        )}
      </td>
      <td onClick={() => setShowInput(false)}>
        {currency(el.costPrice, {
          symbol: "",
        }).format()}
      </td>
      <td>
        {currency(el.subtotal, {
          symbol: "",
        }).format()}
      </td>
      <td>
        {issueToData?.find(item => item.value === el.issueTo)?.label ||
          el.issueTo}
      </td>
      <td>
        {receivingOfficers?.find(item => item.value === el.receivingofficer)
          ?.label || el.receivingofficer}
      </td>
      <td>
        {contracts.find(item => item.value === el.theSelectedJob)?.label || ""}{" "}
        {el.theSelectedJobPoNumber ? `- ${el.theSelectedJobPoNumber}` : ""}
      </td>
      <td>
        {storageLocation?.find(item => item.value === el.StorageLocation)
          ?.label || ""}
      </td>
      <td>
        {el?.issueDate?.format("DD/MM/YYYY")}
        <span className="mx-3 p-cursor" onClick={() => deleteItem(index)}>
          <DeleteIcon width="14" height="14" />
        </span>
      </td>
    </tr>
  );
};

export default WarehouseIssueItemModalTable;
